import React from 'react';

// components
import { Grid } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

// assets
import iconInfoParticipationFees1 from '../../../assets/img/icon-info-participation-fees-1.svg';
import iconInfoParticipationFees2 from '../../../assets/img/icon-info-participation-fees-2.svg';
import iconInfoParticipationFees4 from '../../../assets/img/icon-info-participation-fees-4.svg';

const CardInfoParticipationFees = () => {
  return (
    <SimpleCard
      contentHeader={<p className="simplecard__title">¿Qué es la cuota de participación?</p>}
    >
      <Grid row className="m-0 padding-16 p-md-6">
        <Grid className="p-0 d-flex mb-3" col={12}>
          <p className="font-size-14 line-height-22">
            Es una
            <strong> inversión mensual </strong>
            que te permitirá a ti y a los demás socios(as) participar de los beneficios de la
            cooperativa. Entre ellos el remanente.
          </p>
        </Grid>
        <Grid
          className="p-0 d-flex flex-column justify-content-start align-items-center"
          col={12}
          md={4}
        >
          <img src={iconInfoParticipationFees1} alt="" width="48" height="48" className="" />
          <p className="font-size-16 line-height-22 font-weight-bold text-center px-4 mt-2">
            ¿Qué es el remanente?
          </p>
          <p className="p-0 px-4 mt-2 text-center font-size-14 line-height-20">
            Es el resultado financiero positivo de la gestión de la cooperativa cada año.
          </p>
        </Grid>
        <Grid
          className="p-0 d-flex flex-column justify-content-start align-items-center mt-2 mt-md-0"
          col={12}
          md={4}
        >
          <img src={iconInfoParticipationFees2} alt="" width="48" height="48" className="" />
          <p className="font-size-16 line-height-22 font-weight-bold text-center px-4 mt-2">
            Remanente para socios(as)
          </p>
          <p className="p-0 px-4 mt-2 text-center font-size-14 line-height-20">
            Hay remanente cuando el resultado es favorable. En 2022 se distribuyeron $62.274
            millones.
          </p>
        </Grid>
        <Grid
          className="p-0 d-flex flex-column justify-content-start align-items-center mt-2 mt-md-0"
          col={12}
          md={4}
        >
          <img src={iconInfoParticipationFees4} alt="" width="48" height="48" className="" />
          <p className="font-size-16 line-height-22 font-weight-bold text-center px-4 mt-2">
            ¿Cómo aumentas tu remanente?
          </p>
          <p className="p-0 px-4 mt-2 text-center font-size-14 line-height-20">
            Al pagar tus cuotas de participación, contratar y usar tus productos Coopeuch.
          </p>
        </Grid>
      </Grid>
    </SimpleCard>
  );
};

export default CardInfoParticipationFees;
